import { DEPARTMENTS } from "../config/api";

const aliases = new Map([
  ["hr", "HR"],
  ["кадры", "HR"],
  ["отдел кадров", "HR"],
  ["отдел персонала", "HR"],
  ["administration", "Администрация"],
  ["admin", "Автоматизация"],
  ["админ", "Автоматизация"],
  ["административный", "Администрация"],
  ["административный отдел", "Администрация"],
  ["automation", "Автоматизация"],
  ["it", "Автоматизация"],
  ["ит", "Автоматизация"],
  ["информационные технологии", "Автоматизация"],
  ["информационные системы", "Автоматизация"],
  ["billing", "Бухгалтерия"],
  ["бухгалтерский отдел", "Бухгалтерия"],
  ["бухгалтерский", "Бухгалтерия"],
  ["paperworks", "Делопроизводство"],
  ["делопроизводственный", "Делопроизводство"],
  ["personal_staff", "Личный персонал"],
  ["личный состав", "Личный персонал"],
  ["личный", "Личный персонал"],
  ["logistics", "Логистика"],
  ["логистический", "Логистика"],
  ["логистический отдел", "Логистика"],
  ["art", "Транспортный"],
  ["атп", "Транспортный"],
  ["водитель", "Транспортный"],
  ["transport", "Транспортный"],
  ["development", "Эквиум"],
  ["развитие", "Эквиум"],
  ["отдел развития", "Эквиум"],
  ["legals", "Юридический"],
  ["юристы", "Юридический"],
  ["юридический отдел", "Юридический"],
  ["строительный", "Строительство"],
  ["строительный отдел", "Строительство"],
  ["офисный", "Офис"],
  ["офисный отдел", "Офис"],
  ["ресторанный", "Ресторан"],
  ["ресторанный отдел", "Ресторан"],
]);

const canonicalByKey = new Map(DEPARTMENTS.map((value) => [value.toLocaleLowerCase("ru-RU"), value]));

/** Convert known ERP labels/codes to the hiring-request department enum. */
export function normalizeHiringRequestDepartment(value) {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  const key = trimmed.toLocaleLowerCase("ru-RU").replaceAll("ё", "е");
  return canonicalByKey.get(key) || aliases.get(key) || "";
}

export const HIRING_REQUEST_DEPARTMENT_OPTIONS = DEPARTMENTS.map((department) => [
  department,
  department,
]);
